import axios from "axios";
import { useEffect, useState } from "react";
import Product from "./Product";

function SuggestedProducts({ categorySlug }) {
  const [products, setProducts] = useState(null);
  const getProducts = async () => {
    const response = await axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/api/categories/${categorySlug}`,
    });
    setProducts(response.data.products);
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <div className="row px-0 justify-content-center gx-5 gy-4">
      {products &&
        products.map(
          (item, i) =>
            i < 4 && (
              <div
                key={item.id}
                className="col-lg-3 col-6 d-flex justify-content-center"
              >
                <Product product={item} />
              </div>
            )
        )}
    </div>
  );
}

export default SuggestedProducts;
